import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import React from 'react';
import ids from '../../QestIds';
import { BsDryMassesSection, BsPreparationSection, BsResultsSection, BsMeasurementsSection } from './Sections';

const qestIds = [ids.moistureContent.BS_1377_2.rev1990];

let BsMeasuredMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <BsPreparationSection />
    <BsMeasurementsSection />
    <BsDryMassesSection />
    <BsResultsSection />
  </>
);

BsMeasuredMoistureContentWorksheet.qestIds = qestIds;

export default BsMeasuredMoistureContentWorksheet;
export { BsMeasuredMoistureContentWorksheet };
